<template>
  <div class="assessment_main">
    <div class="assessment_title">
      <h2>智能审计</h2>
    </div>
    <ul v-if="productFlag==3">
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsj:sj')">
        <img src="../img/znsj-logo.png" alt="" class="app_logo" style="height: 30px">
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('sj')">进入系统</el-button>
      </li>
      <!-- 政府审计案例库 -->
      <li>
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <p class="text">政府审计案例库</p>
        <el-button @click="jumpLink('sjalk')">进入系统</el-button>
      </li>
      <!-- 中央纪委国家监委法规库 -->
      <li>
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <p class="text">中央纪委国家监委法规库</p>
        <el-button @click="jumpLink('jwfgk')">进入系统</el-button>
      </li>
      <!-- 审计署法律法规库 -->
      <li>
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <p class="text">审计署法律法规库</p>
        <el-button @click="jumpLink('sjflfgk')">进入系统</el-button>
      </li>
      <!-- 证券期货法规数据库系统 -->
      <li>
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <p class="text">证券期货法规数据库系统</p>
        <el-button @click="jumpLink('zqfgsjk')">进入系统</el-button>
      </li>
      <!-- 财政部法律法规库 -->
      <li>
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <p class="text">财政部法律法规库</p>
        <el-button @click="jumpLink('czflfgk')">进入系统</el-button>
      </li>
    </ul>
    <ul v-if="productFlag==4">
      <li v-if="isStudent||$_has('zledu.gxzx.zsrwappsj:sj')">
        <img src="../img/znsj-logo.png" alt="" class="app_logo" style="height: 30px">
        <img src="../img/znsj-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('sj')">进入系统</el-button>
      </li>
    </ul>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto'
import * as userApi from '../../../../api/userApi'
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      sysUserPermissionList: JSON.parse(localStorage.getItem('sysUserPermissionList'))  || [], // 权限对象
      userType: sessionStorage.getItem('userType'), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem('productFlag'),
    };
  },
  created() {
    if(this.userType==2 || this.userType==3){
      this.isStudent = true
    }else{
      this.isStudent = false
    }
  },
  methods: {
    setSha1(url,secretKey){// 加密
      let hmac = crypto.createHmac('sha1', secretKey || '123456');
      hmac.update(url);
      return hmac.digest('hex');
    },
    getJumpInfo(sys){// 跳转所用参数集合
      let that = this
      let userId = sessionStorage.getItem('userId')
      let productFlag = sessionStorage.getItem("productFlag"); // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务
      let courseId = userId+"8888"
      let classId = userId+"9999"
      let qstId = '0'
      let identity = ""
      /*
        encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
        系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
        123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
        999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
        2: (单项: 1)、（实训: 2）
        200: (单项: NONE)、（实训: teamId）
        001: templateCode
      */
      let encrypted = ""
      if(productFlag == 2){ //单项
        identity = sys + 'dx'
        encrypted = `TEACH_${courseId}_${classId}_1_NONE`
      }else if(productFlag == 3){ //综合
        identity = sys + 'zh'
        encrypted = `TEACH_${courseId}_${classId}_1_NONE`
      }else if(productFlag == 4){ //真实任务
        identity = sys + 'zh'
        encrypted = `TEACH_${courseId}_${classId}_1_0`
      }
      let obj = {
        token: localStorage.getItem('Authorization'),
        courseId: courseId,// 课程id
        classId: classId,// 班级id
        qstId: qstId,//试题id
        schoolId: sessionStorage.getItem("deptId"),// 机构id
        orgName: sessionStorage.getItem("schoolName"),// 机构名称
        username: sessionStorage.getItem("userName"),// 账号
        userId: userId,// 用户id
        nickname: sessionStorage.getItem("loginName"),// 用户姓名
        userType: sessionStorage.getItem("userType"),// 用户类型
        mobile: sessionStorage.getItem("mobile"),// 手机号
        sex: sessionStorage.getItem("sex"),// 性别
        headImgUrl: "",// 头像
        idCard: "",// 身份证
        password: 'e10adc3949ba59abbe56e057f20f883e',
        // item: ${questionDto.questionCode},
        item: '27011201-6fe9-46b4-ba7f-fe241aed2132',// questionCode
        identity: identity,
        encrypted: encrypted,
        clientId: '1349883712819109890',
        timestamp: new Date().getTime(),
        roleCodes: "3001",
        templateCode: ""
      }
      return obj
    },
    async zljtLogin(type){// 中联集团登录
      let jumpObj = this.getJumpInfo(type)
      // 加密参数
      let shanStr = `{clientId=${jumpObj.clientId}, encrypted=${jumpObj.encrypted}, identity=${jumpObj.identity}, item=${jumpObj.item}, qstId=${jumpObj.qstId}, roleCode=${jumpObj.roleCodes}, templateCode=${jumpObj.templateCode}, timeStamp=${jumpObj.timestamp}, token=${jumpObj.token}, userType=${jumpObj.userType}, username=${jumpObj.username}}`;
      let secretKey = this.setSha1(shanStr, '02424D4FD04A007E453DADA28E4EEE37')
      let params = {
        clientId: jumpObj.clientId,
        encrypted: jumpObj.encrypted,
        identity: jumpObj.identity,
        item: jumpObj.item,
        qstId: jumpObj.qstId,
        roleCode: jumpObj.roleCodes,
        sign: secretKey,
        templateCode: jumpObj.templateCode,
        timeStamp: jumpObj.timestamp,
        token: jumpObj.token,
        userId: jumpObj.userId,
        userType: jumpObj.userType,
        username: jumpObj.username,
      }
      let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`
      return axios.post(src, params).then(rs=>rs)
    },
    entrySys(sys){
      let that = this
      if(localStorage.getItem('Authorization')){
        userApi.isExpired(localStorage.getItem('Authorization')).then(rs=>{
          if(rs.code==0 && rs.data==0){
            let jumpObj = that.getJumpInfo(sys)
            if(sys=='sj'){
              that.zljtLogin(sys).then((rs)=>{
                if(rs.data.code==0){
                  let host = process.env.XSJ_API
                  let jumpStr= `token=${rs.data.data.access_token}&gxzxToken=${jumpObj.token}`
                  let Base64url = `${Base64.encode(jumpStr)}`
                  let src = `${host}?${Base64url}`
                  window.open(src)
                }else{
                  that.$messageError(rs.data.msg)
                }
              })
            }else{
              this.loading = false
              this.$messageWarning('暂无权限，请联系管理员！')
            }
          }else{
            this.$router.push({path:'/home'})
            this.$messageError('登录已过期，请重新登录')
            localStorage.removeItem('Authorization')
            localStorage.removeItem('isbinding')
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        this.loading = false
        this.$router.push({path:'/home'})
      }
    },
    jumpLink(type) {
      if (type == "sjalk") { // 政府审计案例库
        window.open("https://www.audit.gov.cn/n5/n25/index.html")
      } else if (type == "jwfgk") { // 中央纪委国家监委法规库
        window.open("https://www.ccdi.gov.cn/fgk/index")
      } else if (type == "sjflfgk") { // 审计署法律法规库
        window.open("https://www.audit.gov.cn/n6/n36/index.html")
      } else if (type == "zqfgsjk") { // 证券期货法规数据库系统
        window.open("https://neris.csrc.gov.cn/falvfagui/")
      } else if (type == "czflfgk") { // 财政部法律法规库
        window.open("http://fgk.mof.gov.cn/ui/start/#/outerHomePage/outerHome")
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.assessment_main{
  .assessment_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      width:278px;
      height:180px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 8px rgba(0,0,0,0.16);
      border-radius:4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo{
        position: absolute;
        left: 40px;
        top: 48px;
        z-index: 2;
        height: 22px;
      }
      .app_bg{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width:278px;
        height:180px;
      }
      button{
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width:96px;
        height:34px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(83,151,247,1);
        border-radius:4px;
        padding: 0;
        color: #5397F7;
        &:hover{
          background: #5397F7;
          color: #fff;
        }
      }
      .text{
        padding: 0 40px;
        position: absolute;
        top: 28%;
        z-index: 2;
        font-size: 24px;
        color: #004e97;
        font-weight: 600;
        line-height: 1.2em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/audit.vue